import React from 'react';
import styled from 'styled-components';
import Button, { ButtonColor } from '../buttons/Button';
import personJumping from '../../../assets/person_jumping.png';
import { ReactComponent as CrownPointy } from '../../../assets/icons/crown-pointy.svg';
import { ReactComponent as CheckCircle } from '../../../assets/icons/Check_circle.svg';
import { Breakpoints } from '../../../stylesGlobal/Variables';

interface Props {
  handleDownloadWithWatermark: () => void;
  title?: string;
}

const PremiumModalWrapper = styled.div`
  display: grid;
  grid-template-columns: auto;
  border-radius: var(--rounded-lg);
  overflow: hidden;

  @media (min-width: ${Breakpoints.lg}) {
    grid-template-columns: 36rem 56rem;
  }

  .content {
    background: var(--color-white);
    display: grid;
    align-content: center;
    gap: 1.5rem;
    padding: 5rem;
    padding-block: 8rem;
    max-width: 36rem;

    @media (min-width: ${Breakpoints.lg}) {
      max-width: auto;
    }

    .upgrade-title {
      display: flex;
      align-items: center;
      gap: 0.6rem;
      font-size: 12px;

      svg {
        width: 3.2rem;
        height: 3.2rem;
        background: #dac13e1a;
        border-radius: var(--rounded-full);
        padding: 0.8rem;
      }
    }

    h3 {
      color: var(--color-gray-800);
      font-size: 3rem;
      font-weight: 600;
      line-height: 3.6rem;
    }

    .list {
      display: grid;
      gap: 10px;
      li {
        display: flex;
        align-items: center;
        gap: 6px;
      }
      svg {
        width: 2.4rem;
        height: 2.4rem;
      }
      span {
        flex: 1;
        font-size: 1.2rem;
      }
    }
    .upgrade-button {
      display: grid;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: none;
  }

  @media (min-width: ${Breakpoints.lg}) {
    img {
      display: block;
    }
  }

  .font-base {
    color: var(--color-gray-800);
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2rem;
  }
`;

const PremiumModal: React.FC<Props> = (props) => {
  return (
    <PremiumModalWrapper>
      <div className="content">
        <div className="upgrade-title">
          <CrownPointy />
          Upgrade
        </div>
        {props?.title && <h3>{props.title}</h3>}
        <p className="font-base">Go premium to unlock exclusive features, only for subscribers:</p>
        <ul className="list font-base">
          <li className="font-base">Including:</li>
          <li>
            <CheckCircle />
            <span>Downloads from Graphic Library</span>
          </li>
          <li>
            <CheckCircle />
            <span>Unlimited access to Online Designer</span>
          </li>
          <li>
            <CheckCircle />
            <span>Unlimited access to Mockup Generator</span>
          </li>
          <li>
            <CheckCircle />
            <span>AI credits for image generations, Vectorizer & more</span>
          </li>
        </ul>
        <a target="_blank" href="https://www.vexels.com/merch-plans/mg" className="upgrade-button">
          <Button
            label="Check Plans"
            color={ButtonColor.gray}
            onClick={() => null}
            borderRadius="var(--rounded-lg)"
          />
        </a>
        <Button
          label="Download with Watermark"
          color={ButtonColor.gray10}
          onClick={() => props.handleDownloadWithWatermark()}
          borderRadius="var(--rounded-lg)"
          textColor="var(--color-gray-800)"
        />
      </div>
      <img src={personJumping} alt="person jumping" />
    </PremiumModalWrapper>
  );
};

export default PremiumModal;
